module.exports = __webpack_public_path__ + "static/media/terraform.17e9dc6b.svg";